import style from "../style/layout.module.css";
import { WorldCupBar } from "../components";
import { useEffect, useState } from "react";
export default function Progress({
  progressRound,
  round,
  completedRound,
  gameProgress,
}) {
  const [matchRound, setMatchRound] = useState(8);
  const [curArray, setCurArray] = useState([]);
  useEffect(() => {
    setCurArray(Array.from({ length: matchRound }).map(() => ""));
  }, [matchRound]);
  const matchNumber = () => {
    if (matchRound === 8) {
      return gameProgress.game8.map((li, idx) => (
        <li key={`heart_${idx}`}>
          <img src="/worldcup/imgs/heart_fill.png" alt="" />
        </li>
      ));
    }
    if (matchRound === 4) {
      return gameProgress.game4.map((li, idx) => (
        <li key={`heart_${idx}`}>
          <img src="/worldcup/imgs/heart_fill.png" alt="" />
        </li>
      ));
    }

    if (matchRound === 2) {
      return gameProgress.game2.map((li, idx) => (
        <li key={`heart_${idx}`}>
          <img src="/worldcup/imgs/heart_fill.png" alt="" />
        </li>
      ));
    }
  };
  useEffect(() => {
    if (gameProgress.game16.length === 16 && gameProgress.game8.length < 8) {
      setMatchRound(8);
    }
    if (gameProgress.game8.length === 8 && gameProgress.game4.length < 4) {
      setMatchRound(4);
    }

    if (gameProgress.game4.length === 4 && gameProgress.game2.length < 2) {
      setMatchRound(2);
    }

    if (gameProgress.game2.length === 2 && gameProgress.last.length === 0) {
      setMatchRound(1);
    }
  }, [gameProgress]);

  return (
    <div className={style.progress}>
      <h3 className={style.curRound}>{round()}</h3>
      {matchRound !== 1 && (
        <div
          style={{
            display: "flex",
            gap: 10,
            marginTop: 5,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className={style.round}>
            <ul className={style.round_match}>
              {curArray?.map((_, idx) => (
                <li key={`heart_${idx}`}>
                  <img src="/worldcup/imgs/heart.png" alt="heart" />
                </li>
              ))}
            </ul>
            <ul className={style.round_match}>
              <li>
                <img src="/worldcup/imgs/heart_fill.png" alt="heart_fill" />
              </li>

              {matchNumber()}
            </ul>
          </div>
          <WorldCupBar
            currendRound={completedRound + 1}
            gameProgress={gameProgress}
          />
        </div>
      )}
    </div>
  );
}
